export default function Error({text}) {
    return (
        <div className="error">
            <p>{text}</p>
        </div>
    )
};